import { Injectable } from '@angular/core';
import { config } from 'config';
import { LoaderService } from './loader.service';
import { appSetting } from 'config/appSettings';
import { Router } from '@angular/router';
import { UserDataService } from './user-data.service';

@Injectable()
export class AppHelperService {

    constructor(
        private loaderService: LoaderService,
        private userDataService: UserDataService,
        private router : Router
    ) { }

    isAbsoluteUrl(url) {
        let pat = /(^https?:\/\/)|(^\/\/)/i;
        return pat.test(url);
    }
    
    // This method navigates the user to the dashboard. Pass the correct 'pathParams' based on the user's role. 
    // If the role or tab information is unavailable, pass an empty array. The method will handle the navigation accordingly.
    navigateToDashboardApp(pathParams, options?) {
        pathParams = pathParams.length > 0 ? pathParams : this._getUrlArrayBasedOnRole();
        this.navigateToApp(config.dashboardAppDomain, pathParams, options);
    }

    navigateToOnboardingApp(pathParams, options?) {
        this.navigateToApp(config.onBoardingAppDomain, pathParams, options);
    }

    navigateToAdminApp(pathParams, options?) {
        this.navigateToApp(config.adminAppDomain, pathParams, options);
    }

    navigateToClassApp(pathParams, options?) {
        this.navigateToApp(config.classAppDomain, pathParams, options);
    }

    navigateToApp(domain, pathParams, options){
        this.loaderService.showOverlayLoader();
        if (options && options.outsideC1Url && this.isAbsoluteUrl(options.outsideC1Url)) {
            if (options.openInNewTab) {
                this.loaderService.hideLoader();
                window.open(options.outsideC1Url, "_blank");
                return;
            }
            return this.router.navigate(['/externalRedirect', { externalUrl: options.outsideC1Url }], {
                skipLocationChange: true,
            });
        }
        let externalUrl = domain + pathParams.join('/');
        if (options && options.queryParams && Object.keys(options.queryParams).length > 0) {
            externalUrl += '?' + Object.keys(options.queryParams).map(key => `${key}=${options.queryParams[key]}`).join('&');
        }
        if (options && options.hashParams && Object.keys(options.hashParams).length > 0) {
            externalUrl += '#' + Object.keys(options.hashParams).map(key => `${key}=${options.hashParams[key]}`).join('&');
        }
        if (options && options.forceExit) {
            window.location.href = externalUrl;
        } else {
            this.router.navigate(['/externalRedirect', { externalUrl }], {
                skipLocationChange: true,
            });
        }
    }

    // This function returns banner data from the local storage.
    getBannerDataFromLocalStorage(extUserId) {
        const key = `${appSetting.localStorage.messageBanner}${extUserId}`;
        const localStorageMsgBannerData = localStorage.getItem(key);
        if (localStorageMsgBannerData) {
            const msgBannerData = JSON.parse(localStorageMsgBannerData);
            localStorage.removeItem(key);
            return msgBannerData;
        }
    }

    isProductSuppressed(product, flag, spaceId) {
        // spaceid is of the form 'org_mqa-sierra-thor'.
        let isMQA = spaceId.indexOf("mqa") === 4;        

        // check if org is mqa. if true show irrespective of visibility flag.
        // check if visibility is true, display if true.
        // product is hidden when org is non mqa and visibility is false.
        let isHidden = !isMQA && product && product['meta'] && (product['meta']['visibility'] == 'false' || product['meta']['visibility'] == 'coming-soon');

        // NEMO-6677 : suppress products with visibility hidden or visibility options false.
        if (isHidden || product && product['meta'] && product['meta']['visibility-options'] && product['meta']['visibility-options'][flag]) {
            return true;
        }
        return false;
        
    }
    
    showLoaderAndNavigateToDashboard() {
        this.loaderService.showOverlayLoader();
        this.router.navigate([]); // to prevent the execution of component code, router.navigate will navigate user to dashboard after checking the logged user's role in "isUserAuthentcatedRoutesGuard". 
    }

    /*
        * This function is used for getting required query params from existing query params in url
    */
    getRequiredQueryParams(parmsObject, requiredFields) {
        let mappedQuery = {};
        requiredFields.forEach(param=>{
            if(parmsObject.hasOwnProperty(param)) {
                mappedQuery[param] = parmsObject[param];
            }
        })
        return mappedQuery;
    }

    getLastTimeStampForDate(timestamp) {
        const date = new Date(timestamp);
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        date.setMilliseconds(999);
        return date.getTime();
    }

    getCookie(name) {
        let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }

    // Returns the URL based on the user's role and last visited tab.
    // If the user is a teacher, it retrieves the last visited tab from local storage.
    // If the last visited tab is available, it sets the tab to that value.
    // Returns an array with the user's role and the selected tab.
    _getUrlArrayBasedOnRole() {
        const userData = this.userDataService.getUserData();
        let role = userData.role;
        // Default tab
        let tab = 'dashboard';

        if (role === 'teacher') {
            // Generate a key for local storage using the user's external ID (extUserId)
            const key = appSetting.localStorage.dashboard(userData.extUserId);

            // Retrieve the last visited tab data from localStorage using the key
            const lastVisitedTab = localStorage.getItem(key);

            // If last visited tab data exists and contains a valid selectedTab, update the tab to selectedTab
            if (lastVisitedTab) {
                const { selectedTab } = JSON.parse(lastVisitedTab);
                if (selectedTab) {
                    tab = selectedTab;
                }
            }
        } else if (role == 'student') {
            role = 'learner';
        }

        return [role, tab];
    }
}
